import InternalPromotionVacancy from './InternalPromotionVacancy';

export default InternalPromotionVacancy;
